const escapeDOMId = (str) => {
  return str.replace('.', '-')
}

export default escapeDOMId
